import React from 'react';
import Footer from './Footer';
import AssistantLauncher from '../assistant/AssistantLauncher';

interface CoursePlayerLayoutProps {
  children: React.ReactNode;
}

/**
 * Immersive, focused shell for the course-taking flow (course detail, sections
 * grid, per-section modules, the module player, evaluation/feedback, and the
 * /done celebration). It intentionally drops the sidebar and header so the
 * course content owns the full viewport — preserving the behaviour previously
 * baked into `LearnerLayout`'s `immersive` branch.
 */
const CoursePlayerLayout: React.FC<CoursePlayerLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-background-primary">
      {/* No overflow-y-auto here: the window is the scroller, and an
          overflow ancestor that never actually scrolls silently disables
          position:sticky for the progress header inside. */}
      <main className="flex flex-col pt-2 min-h-screen">{children}</main>
      <Footer />
      <AssistantLauncher />
    </div>
  );
};

export default CoursePlayerLayout;
